<template>
  <div class="order-progress">
    <!-- h5 -->
    <template v-if="isH5">
      <DrawerDialog :showInput="false" :title="title" v-model="visibleDialog">
        <div class="progress-box">
          <div class="progress-content">
            <div v-for="(item, index) in orderFlows" :key="index">
              <ProgressItme
                :listInfo="item"
                :lastIndex="index + 1 == orderFlows.length"
              />
            </div>
          </div>
        </div>
      </DrawerDialog>
    </template>
    <!-- pc -->
    <template v-else>
      <el-floating
        :width="widthSelectAddress"
        :title="title"
        :visible.sync="visibleDialog"
        :append-to-body="true"
        :close-on-click-modal="false"
        custom-class="el-floating_d-reset"
        icon-class="icon-outline_close"
      >
        <div class="progress-box">
          <div class="progress-content">
            <div v-for="(item, index) in orderFlows" :key="index">
              <ProgressItme
                :listInfo="item"
                :lastIndex="index + 1 == orderFlows.length"
              />
            </div>
          </div>
          <div class="progress-confrim">
            <el-button @click="visibleDialog = false">{{$t('确认')}}</el-button>
          </div>
        </div>
      </el-floating>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ProgressItme from './progressItme.vue';
import DrawerDialog from '../DrawerDialog';
export default {
  name: 'OrderProgress',
  components: {
    ProgressItme,
    DrawerDialog,
  },
  props: {
    orderFlows: Array,
    Visible: Boolean,
    orderId: String,
    status: Number,
  },
  watch: {
    visibleDialog(newV) {
      if (newV) {
        this.$trackEvent({
          eventId: 'sailing_c_x_orderpage_main_title_ck',
          eventLabel: '订单页面主状态标题点击',
          attrs: {
            order_id: this.orderId,
            order_status: this.status,
          },
        });
      }
    },
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
    }),
    visibleDialog: {
      get: function() {
        return this.Visible;
      },
      set: function(value) {
        this.$emit('showsChange', value);
      },
    },
  },
  data() {
    return {
      title: this.$t('订单跟踪'),
      widthSelectAddress: '470px',
    };
  },
  model: {
    prop: 'Visible',
    event: 'showsChange',
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss">
@media screen and (max-width: 768px) {
  .order-progress {
    .el-drawer {
      height: auto !important;
      max-height: 92%;
    }
  }
}
</style>
